import axios from "@/utils/request";
import { snkd } from "@/api/api";

// 获取省市区
export const getProvinceCityArea = (params) => {
  return axios.post(snkd.foundation.area.listByParentId, params);
};

// 获取oss 参数
export const getFileEncryptParam = () => {
  return axios.get(snkd.foundation.file.encryptParam, {});
};

// upload
export const upload = (params) => {
  return axios.post(snkd.foundation.file.upload, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
